/**
 * Maping errors from API
 * @param {object} errors - recived errors list
 * @param {callback function} setError - setting errors in current form
 */
export function handleErrorResponse(errors, setError, keyReplace = true) {
  if (errors && typeof errors === 'object') {
    return Object.keys(errors).map((key) => {
      if (keyReplace) {
        const dashlessColumnName = key.replaceAll('_', ' ');
        setError(key, { message: errors[key][0].replace(`The ${dashlessColumnName}`, '').replace('.', '') });
      } else {
        setError(key, { message: errors[key][0].replace('.', '') });
      }
    });
  } else {
    return [];
  }
}

/**
 * This function generates a list of error messages.
 * For each key-value pair in the 'errors' object, a list item is created.
 * The key and value are displayed in the list item, with the key replaced by the corresponding label from moduleFields if it exists.
 * If the error message is empty, 'field is required' is displayed instead.
 *
 * @param {object} errors - The errors object, where each key is an error key and the corresponding value is an error message.
 * @param {Array} moduleFields - Optional. An array of objects where each object has an 'id' and 'label_name' property. If provided,
 *                               the key in the list item will be replaced by the corresponding label_name where the id matches the key.
 * @returns {JSX.Element} A list of error messages in JSX.
 */
export function generateErrorBody(errors, moduleFields = []) {
  return (
    <ul style={{ listStyle: "disc", marginLeft: "25px" }}>
      {Object.entries(errors).map(([key, value]) => {
        // Find the corresponding moduleField
        const moduleField = moduleFields.find((field) => field.column_name === key);

        // If a corresponding moduleField was found, use its label_name, otherwise use the key
        const label = moduleField ? moduleField.label_name : formatAndCapitalizeString(key);

        return (
          <li key={key}>{label} {(value.message === "" || !value.message) ? 'field is required' : value.message}</li>
        );
      })}
    </ul>
  );
}

export function generateArrayOfErrorsToBody(errors) {
  return (
    <ul style={{ listStyle: "disc", marginLeft: "25px" }}>
      {errors.map((error, index) => {
        return (
          <li>{Object.keys(error)}: {Object.values(error)}</li>
        );
      })}
    </ul>
  );
}

function formatAndCapitalizeString(inputString) {
  return inputString
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
